import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const COOKIE_KEY = 'omas_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => { localStorage.setItem(COOKIE_KEY, 'accepted'); setVisible(false); };
  const decline = () => { localStorage.setItem(COOKIE_KEY, 'declined'); setVisible(false); };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          className="fixed bottom-28 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[90]"
          data-testid="cookie-banner"
        >
          <div className="bg-card border-2 border-border rounded-2xl shadow-2xl p-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0">
                <Cookie className="w-5 h-5 text-gold" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-foreground text-sm mb-1">{t('cookie.title')}</h3>
                <p className="text-xs text-muted-foreground leading-relaxed mb-3">
                  {t('cookie.text')}{' '}
                  <a href="/privacy" className="text-gold hover:underline">{t('cookie.privacy')}</a>.
                </p>
                <div className="flex gap-2">
                  <Button data-testid="cookie-accept" onClick={accept} size="sm" className="rounded-full bg-gold hover:bg-gold/90 text-night-blue font-bold text-xs px-4">
                    {t('cookie.accept')}
                  </Button>
                  <Button data-testid="cookie-decline" onClick={decline} variant="ghost" size="sm" className="rounded-full text-xs">
                    {t('cookie.decline')}
                  </Button>
                </div>
              </div>
              <button onClick={decline} className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
